// extracted by mini-css-extract-plugin
module.exports = {"trigger":"modal-module--trigger--2toOl","headline":"modal-module--headline--xdatb","close":"modal-module--close--2HZbF"};